// What the server document and the browser both need to agree on about the
// theme (C27), written once because they are two bundles.
//
// The cookie carries only `light` or `dark`, the theme an account fixed, and
// is absent when the account follows the device. It names a colour and nothing
// about the person; it exists so the server can draw the document in the right
// theme from the first paint, since the web service never reads a session.
export const themeCookie = 'psy_theme';

// Each theme's ground, which is also the colour the browser paints around the
// page (`theme-color`). They match --bg in components/page/style.css.
export const grounds = {
  light: '#EEF1EA',
  dark: '#141713'
};
